export const singleTypeFilesViewerModalName = 'single-type-files-viewer';
